import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { useAuth } from '../contexts/AuthContext';
import { loadNativeShare, onNativeShare } from '../utils/sharedContent';

/**
 * Picks up "Share to Bazzef" content (Android intent / iOS App Group) when the
 * app opens with it, or when a share arrives while it is open (Android; on iOS
 * the extension opens bazzef://share, which routes to the share screen), and
 * opens the share screen once the user is logged in.
 */
export default function ShareIntentHandler() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [pending, setPending] = useState(false);

  useEffect(() => {
    const load = () => loadNativeShare().then((content) => {
      if (content) setPending(true);
    });
    // Give the native bridge a moment on cold start
    const timer = setTimeout(load, 400);
    const off = onNativeShare(load);
    // iOS: the share extension opens bazzef://share, also while the app is running
    const urlHandle = Capacitor.isNativePlatform()
      ? App.addListener('appUrlOpen', ({ url }) => {
        if (url?.startsWith('bazzef://share') || url?.startsWith('bazzefmessenger://share')) load();
      })
      : null;
    return () => {
      clearTimeout(timer);
      off();
      Promise.resolve(urlHandle).then((h) => h?.remove()).catch(() => {});
    };
  }, []);

  useEffect(() => {
    if (!user || !pending) return;
    setPending(false);
    if (pathname !== '/share') navigate('/share');
  }, [user?.id, pending, pathname, navigate]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
